import {
  Box,
  Button,
  Grid,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import AppBar from "app/components/AppBar/AppBar";

import Layout from "app/layout/Layout";
import colors from "app/style/Colors";
import React, { useEffect, useState } from "react";
import Step1CreateProduct from "./Steps/Step1CreateProduct";

import ViewProductWebsite from "./Steps/Step3ViewProduct";
import AddCustomisePictures from "./Steps/Step2AddCustomoisepictures";
import { ErrorToaster } from "app/components/UI/Toaster";
import {
  getColors,
  getMainCategory,
  getSizes,
} from "./Steps/CallingApiForItems";

function AddProducts() {
  let [activeStep, setActiveStep] = useState(0);
  const [data, setData] = useState();

  const [otherDta, setOtherDta] = useState();
  const [customisePicture, setCustomisePicture] = useState([]);

  // calling External Api's

  const [MainCategory, setMainCategory] = useState("");
  const [SizeChange, setSizeChange] = useState("");
  const [ColorChange, setColorChange] = useState("");

  let getcolordata = async () => {
    let colorData = await getColors();
    setColorChange(colorData);
  };
  // Get MainCategory Data
  let getMainCategoryData = async () => {
    let MainCategoryy = await getMainCategory();
    setMainCategory(MainCategoryy);
  };
  // Get Size Data
  let getSizeData = async () => {
    let SizeData = await getSizes();
    setSizeChange(SizeData);
  };

  useEffect(() => {
    getcolordata();
    getMainCategoryData();
    getSizeData();
  }, [URL]);

  // Handle CustomisePictures Data
  const setCustomisePicturesData = (data) => {
    try {
      const currentIndex = customisePicture.findIndex(
        (item) => item.name === data.name
      );

      const newCustomisePicture = [...customisePicture];
      if (currentIndex === -1) {
        newCustomisePicture.push(data);
      } else {
        newCustomisePicture.splice(currentIndex, 1);
        newCustomisePicture.splice(currentIndex, 0, data);
      }
      setCustomisePicture(newCustomisePicture);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleActiveStep = (action, value) => {
    if (action === "next") {
      if (activeStep < 2) {
        setActiveStep(activeStep + value);
      }
    }
    if (action === "prev") {
      if (activeStep > 0) {
        setActiveStep(activeStep - value);
      }
    }
  };

  const HandleSubmit = (data) => {
    setData(data);
  };

  const HandleOtherData = (data) => {
    setOtherDta(data);
  };

  const ColorAndSizeData = () => {};

  return (
    <Layout>
      <AppBar subChild={"Products"}>Add Product</AppBar>
      <Box
        justifyContent="center"
        display={"flex"}
        flexDirection="column"
        alignItems={"center"}
      >
        <Grid
          container
          sx={{
            padding: "20px",
            boxShadow:
              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
            width: "95%",
          }}
        >
          <Stepper sx={{ width: "100%" }} activeStep={activeStep}>
            <Step>
              <StepLabel>Create Product</StepLabel>
            </Step>
            <Step>
              <StepLabel optional>Add Images for customise product</StepLabel>
            </Step>
            <Step>
              <StepLabel optional>Product Info</StepLabel>
            </Step>
          </Stepper>

          {/* Stepper Main */}

          <Box
            display={"flex"}
            justifyContent="center"
            width={"100%"}
            marginTop={"50px"}
            flexDirection="column"
            alignItems={"center"}
          >
            <Box marginBottom={"50px"} width="100%">
              {/* Active Step ======================1 */}
              {activeStep === 0 && (
                <Step1CreateProduct
                  handleStep={handleActiveStep}
                  setData={HandleSubmit}
                  SizeChange={SizeChange}
                  MainCategory={MainCategory}
                  ColorChange={ColorChange}
                  defaultdata={data}
                  SizesAndColorData={HandleOtherData}
                  otherData={otherDta}
                />
              )}
              {activeStep === 1 && (
                <AddCustomisePictures
                  data={data}
                  handleStep={handleActiveStep}
                  setCustomisePicturesData={setCustomisePicturesData}
                  customisePictureData={customisePicture}
                />
              )}
              {activeStep === 2 && (
                <ViewProductWebsite
                  data={data}
                  allColor={ColorChange}
                  allSize={SizeChange}
                  MainCategory={MainCategory}
                  customisePictureData={customisePicture}
                  handleStep={handleActiveStep}
                />
              )}
            </Box>
          </Box>
        </Grid>
      </Box>
    </Layout>
  );
}

export default AddProducts;
